<template>
  <section class="about-how-to-use">
    <AboutPageHeadline title="HOW TO USE" sub-title="ご利用方法" />
    <div class="about-how-to-use__examples">
      <div class="about-how-to-use__01">
        <span class="about-how-to-use__number">01</span>
        <span class="about-how-to-use__text">{{
          '相手やシーンに合ったギフトを選ぶ'
        }}</span>
      </div>
      <div class="about-how-to-use__02">
        <span class="about-how-to-use__number">02</span>
        <span class="about-how-to-use__text">{{
          'カードデザインを選びメッセージを入力'
        }}</span>
      </div>
      <div class="about-how-to-use__03">
        <span class="about-how-to-use__number">03</span>
        <span class="about-how-to-use__text">{{
          '発行されたURLをSNSやメールで送信'
        }}</span>
      </div>
    </div>
  </section>
</template>

<script>
import AboutPageHeadline from '../../../atoms/headlines/AboutPageHeadline'
export default {
  components: { AboutPageHeadline }
}
</script>

<style lang="scss" scoped>
%examples {
  padding-top: 40px;
  width: 432px;
  height: 480px;
  position: relative;
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 220px;
  box-sizing: border-box;

  @media all and (max-width: $pc-width  - 1) {
    width: 100%;
  }

  @media all and (max-width: $sp-iphone5-width) {
    height: 400px;
    background-size: 63%;
  }
}

%examples__odd {
  @extend %examples;
  background-color: $gray-3;

  .about-how-to-use__number {
    color: $gray-2;
  }
}

%examples__even {
  @extend %examples;
  background-color: #f2f2f2;

  .about-how-to-use__number {
    color: $white;
  }
}

.about-how-to-use {
  padding: 0 5%;

  @media all and (max-width: $pc-width  - 1) {
    padding: 0 24px;
  }

  &__examples {
    margin: 40px auto 100px;
    display: flex;
    justify-content: center;
    max-width: calc(1440px - (5% * 2));

    @media all and (max-width: $pc-width  - 1) {
      flex-direction: column;
    }
  }

  &__01 {
    @extend %examples__odd;
    background-image: url('../../../../../../images/abouts/devices/01.png');
    border-radius: 8px 0 0 8px;

    @media all and (max-width: $pc-width  - 1) {
      border-radius: 8px 8px 0 0;
    }
  }

  &__02 {
    @extend %examples__even;
    background-image: url('../../../../../../images/abouts/devices/02.png');
  }

  &__03 {
    @extend %examples__odd;
    background-image: url('../../../../../../images/abouts/devices/03.png');
    border-radius: 0 8px 8px 0;

    @media all and (max-width: $pc-width  - 1) {
      border-radius: 0 0 8px 8px;
    }
  }

  &__number {
    font-weight: bold;
    font-size: 10.8rem;
    line-height: 1;
    position: absolute;
    left: 0;
    top: 0;

    @media all and (max-width: $sp-iphone5-width) {
      font-size: 9.2rem;
    }
  }

  &__text {
    position: relative;
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 1.6;

    @media all and (max-width: 1296px) {
      font-size: 1.6rem;
    }

    @media all and (max-width: $sp-iphone5-width) {
      font-size: 1.4rem;
    }
  }
}
</style>
